import GjwListPageLayout from './src/GjwListPageLayout.vue'

GjwListPageLayout.install = function(Vue) {
  Vue.component(GjwListPageLayout.name, GjwListPageLayout)
}

export default GjwListPageLayout
